import { stringify } from 'querystring';
import { isEmpty } from 'lodash-es';
import { BaseClient } from '@is24at/react-utils';
import { EMPTY_STRING } from '@is24at/react-constants';

export const ACCOUNT_SERVICE_BASE_PATH = '/accounts';

class AccountClient extends BaseClient {
  fetchRealtorData = (cwid: any) =>
    this.fetch(`${ACCOUNT_SERVICE_BASE_PATH}/${cwid}`);

  fetchRealtors(query: any) {
    const queryString = isEmpty(query) ? EMPTY_STRING : `?${stringify(query)}`;
    return this.fetch(`${ACCOUNT_SERVICE_BASE_PATH}${queryString}`);
  }

  fetchRealtorMandatoryFields = (cwid: string) =>
    this.fetch(
      `${ACCOUNT_SERVICE_BASE_PATH}/${cwid}/contactRequestConfiguration`,
    );
}

export default AccountClient;
